import{e as c,k as n,m as o}from"./chunk-HBP5N4FR.js";function a(r){let t=r;try{let e=n.Buffer.from(r,"hex").toString();i(e)&&e.length>1&&(t=e)}catch(e){}return t}var i,f=c(()=>{o();i=r=>{for(let t=0;t<r.length;t++)if(r.charCodeAt(t)>127)return!1;return!0}});export{a,f as b};
//# sourceMappingURL=chunk-H4Z57IQC.js.map
